import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { useCallback, useState } from 'react';
import { isFunction } from '../../../utils/TypeUtils';
import FeedbackButtons from './FeedbackButtons';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InlineFeedbackPopover = ({
  children,
  feedbackPopoverWidth = 325,
  feedbackPopoverMaxInlineSize,
  popoverOpen,
  onSubmit,
  onCancel,
  popoverTitle,
  popoverBody,
  textAreaPlaceholder,
  negativeFeedbackPopoverBodyOptions
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [messageFeedback, setMessageFeedback] = useState('');
  const handleMessageFeedbackChange = useCallback(({
    target: {
      value
    }
  }) => {
    setMessageFeedback(value);
  }, []);
  const handleMessageFeedbackOptionsChange = useCallback(option => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter(e => e !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  }, [selectedOptions]);
  const handleSubmit = useCallback(() => {
    if (isFunction(onSubmit)) {
      onSubmit({
        options: selectedOptions,
        message: messageFeedback
      });
    }
  }, [onSubmit, messageFeedback, selectedOptions]);
  const canSubmit = selectedOptions.length > 0 || messageFeedback.length > 0;
  return /*#__PURE__*/_jsx(Popover, {
    "data-test-id": "inline-feedback-popover",
    inlineSize: `${feedbackPopoverWidth}px`,
    maxInlineSize: feedbackPopoverMaxInlineSize,
    open: popoverOpen,
    onOpenChange: onCancel,
    content: {
      header: /*#__PURE__*/_jsx(Text, {
        as: "h1",
        typography: "heading-100",
        children: popoverTitle
      }),
      body: /*#__PURE__*/_jsxs(_Fragment, {
        children: [popoverBody || /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h2",
            typography: "body-100",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.optionSelectHeader"
            })
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "300",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FeedbackButtons, {
              selectedOptions: selectedOptions,
              onOptionSelect: handleMessageFeedbackOptionsChange,
              negativeFeedbackPopoverBodyOptions: negativeFeedbackPopoverBodyOptions
            })
          })]
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(TextArea, {
            marginBlockEnd: "50",
            typography: "body-100",
            placeholder: textAreaPlaceholder || I18n.text('aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.freeformPlaceholder'),
            onChange: handleMessageFeedbackChange
          })
        })]
      }),
      footer: /*#__PURE__*/_jsxs(ButtonWrapper, {
        justify: "end",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onCancel,
          margin: "0",
          marginInlineEnd: "200",
          type: "reset",
          use: "secondary",
          size: "sm",
          responsive: false,
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.buttons.cancel"
          })
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "inline-feedback-popover-submit",
          onClick: handleSubmit,
          margin: "0",
          type: "submit",
          use: "primary",
          size: "sm",
          disabled: !canSubmit,
          responsive: false,
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.buttons.submit"
          })
        })]
      })
    },
    children: /*#__PURE__*/_jsx(View, {
      as: "span",
      display: "inline-block",
      children: children
    })
  });
};
export default InlineFeedbackPopover;